import type { FC } from 'react';
import React, { useMemo } from 'react';

import { useProgress, useSticky } from './utils/hooks';
import type { TProgress } from './models';

/**
 * Адаптер прогресс-бара
 */
export const Progress: FC<TProgress> = ({
    ProgressBar,
    children,
    className,
    initValue,
    sticky,
    styles,
    wrapperStickedClassNameHelper,
    ...rest
}) => {
    const { isSticky, progressRef } = useSticky(sticky);
    const { fieldProgress, value } = useProgress(initValue);

    const wrapperStickedClassName = useMemo(
        () => wrapperStickedClassNameHelper({ className, isSticky, sticky }),
        [className, isSticky, sticky, wrapperStickedClassNameHelper]
    );

    return (
        <ProgressBar
            className={wrapperStickedClassName}
            field={fieldProgress}
            forwardedRef={progressRef}
            isSticky={isSticky}
            progressBar={{ initValue: initValue || value, ...rest }}
            progressBarFilledValue={value}
        >
            {children}
        </ProgressBar>
    );
};
